import { useState } from "react";
import "./dc-toolbar.css";
import { PromptPair } from "../../wazawan/Wazawan";
import { X } from "lucide-react";

const OBJECT_DISPLAY_NAMES = {
    "employee-record": "Employee Record",
}

type DCToolbarProps = {
    promptPair: PromptPair;
    onClose: () => void;
}

export const DCToolbar = ({promptPair, onClose} : DCToolbarProps) => {

    console.log("[DCToolbar] promptPair: ", promptPair);

    let response : any = {};

    try {
        response = JSON.parse(promptPair.response);
    } catch (e) {
        response = promptPair.response;
    }

    // const response = JSON.parse(promptPair.response);
    const object = response?.object;

    return (
        <div 
            className="dc-toolbar"
        >
            
            <div 
                className="dc-toolbar-close"
                onClick={onClose}
            >
                <X size={24} color="gray" />
            </div>
            <div className="dc-toolbar-object">
                {OBJECT_DISPLAY_NAMES[object as keyof typeof OBJECT_DISPLAY_NAMES]}
            </div>

        </div>
    )
}